import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;  
  flex-direction: column;

  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 2px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06);

  border-radius: 4px;
  transition: 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.034),
      0 5px 10.3px rgba(0, 0, 0, 0.048), 0 24.5px 20px rgba(0, 0, 0, 0.06);
    transform: scale(1.05);
  }

  header {
    padding: 1rem;
    border-bottom: 1px #ddd solid;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    img {
      margin: 0;
    }
    i {
      margin: 0;
    }
  }

  main {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
    padding: 1rem;

    img {
      width: 100%;
      height: auto;
    }

    div {
      margin-top: 1rem;
      width: 100%;
      height: 100%;
      max-height: 10rem;
      overflow-y: auto;
    }
  }

  footer {
    border-top: 1px #ddd solid;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 1rem;
  }
`;
export const Img = styled.img`
width:10%;
`
export const Div = styled.div`
margin-bottom:1rem;
font-size:1rem;
`
